import React, { Component } from 'react';
import Parse                from 'parse';
import Spinner              from './generic/spinner';
import Utils                from '../Utils/Utility';
import Api                  from '../Utils/api';

const URI = 'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write&client_id=';

let stripeImg = require('../../img/stripe-button.png');

export default class AcctCreation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSpinner : false
        };
    }

    componentDidMount() {

    }

    render() {

        const currentUser = Parse.User.current();
        let userId = currentUser.id;
        const currentLocation = this.props.activeLocation;

        var stripeUrl = "";
        if (currentLocation != null){
            let locId = currentLocation.objectId;

            // console.log("PARSE_SP_CLIENT_ID:"+PARSE_SP_CLIENT_ID);
            stripeUrl = URI + PARSE_SP_CLIENT_ID + "&state="+userId+"_"+locId

        }
        else {
            console.log("current location is null");
        }

        // console.log("Stripe Connect URL: "+stripeUrl);
        return (
                <div className="cover acct-creation-pg">
                    { this.state.showSpinner ? <Spinner/> : null }
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1>You Have Successfully Created an Account!</h1>
                                <p>
                                    Now we need your permission to connect to your Stripe account. Note that if you do not<br/>
                                    already have a Stripe account you will be prompted to create one.
                                </p>
                                <br/>
                                <br/>
                                <a className="btn" href={`${stripeUrl}`}>
                                    <img src={stripeImg} alt="Connect with Stripe"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/acct-creation.js